import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://api.tanishqsa.dev";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getStats = () => api.get("/stats").then((r) => r.data);
export const getGithub = () => api.get("/github").then((r) => r.data);
export const getLeetcode = () => api.get("/leetcode").then((r) => r.data);
export const getBlog = () => api.get("/blog").then((r) => r.data);
export const getBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const postContact = (data) => api.post("/contact", data).then((r) => r.data);
export const subscribe = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const unsubscribe = (email) =>
  api.delete("/newsletter/unsubscribe", { params: { email } }).then((r) => r.data);

const adminHeaders = (secret) => ({
  headers: { "X-Admin-Secret": secret },
});

export const verifyAdminSecret = (secret) =>
  api.get("/admin/verify", adminHeaders(secret)).then((r) => r.data);

export const getAdminContacts = (secret) =>
  api.get("/contact", adminHeaders(secret)).then((r) => r.data);

export const getAdminSubscribers = (secret) =>
  api.get("/newsletter", adminHeaders(secret)).then((r) => r.data);

export const deleteContactMessage = (id, secret) =>
  api.delete(`/contact/${id}`, adminHeaders(secret)).then((r) => r.data);

export const deleteSubscriber = (id, secret) =>
  api.delete(`/newsletter/${id}`, adminHeaders(secret)).then((r) => r.data);

export const sendNewsletter = (subject, htmlBody, secret) =>
  api.post("/admin/newsletter/send", { subject, htmlBody }, adminHeaders(secret)).then((r) => r.data);
